import { render, staticRenderFns } from "./IconWrench.vue?vue&type=template&id=c0e3afbe&"
import script from "./IconWrench.vue?vue&type=script&lang=js&"
export * from "./IconWrench.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports